
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { float64_type, option_type, record_type, union_type, list_type, bool_type, class_type, int32_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class FieldValue extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Empty", "StringVal", "CurrencyVal", "IntVal", "DateVal", "BoolVal", "GuidVal", "StringListVal"];
    }
}

export function FieldValue_$reflection() {
    return union_type("Shared.Updater.FieldValue", [], FieldValue, () => [[], [["Item", string_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", class_type("System.DateTime")]], [["Item", bool_type]], [["Item", class_type("System.Guid")]], [["Item", list_type(string_type)]]]);
}

export class ValidationError extends Record {
    constructor(Error$, AdditionalInfo) {
        super();
        this.Error = Error$;
        this.AdditionalInfo = AdditionalInfo;
    }
}

export function ValidationError_$reflection() {
    return record_type("Shared.Updater.ValidationError", [], ValidationError, () => [["Error", string_type], ["AdditionalInfo", string_type]]);
}

export class FieldValidation extends Record {
    constructor(FieldName, FieldNameTranslationKey, OldValue, NewRaw, NewValue, IsValid, Error$) {
        super();
        this.FieldName = FieldName;
        this.FieldNameTranslationKey = FieldNameTranslationKey;
        this.OldValue = OldValue;
        this.NewRaw = NewRaw;
        this.NewValue = NewValue;
        this.IsValid = IsValid;
        this.Error = Error$;
    }
}

export function FieldValidation_$reflection() {
    return record_type("Shared.Updater.FieldValidation", [], FieldValidation, () => [["FieldName", string_type], ["FieldNameTranslationKey", string_type], ["OldValue", FieldValue_$reflection()], ["NewRaw", string_type], ["NewValue", FieldValue_$reflection()], ["IsValid", bool_type], ["Error", option_type(ValidationError_$reflection())]]);
}

export class RowValidation extends Record {
    constructor(ToolId, Name, Fields, IsRowValid) {
        super();
        this.ToolId = ToolId;
        this.Name = Name;
        this.Fields = Fields;
        this.IsRowValid = IsRowValid;
    }
}

export function RowValidation_$reflection() {
    return record_type("Shared.Updater.RowValidation", [], RowValidation, () => [["ToolId", string_type], ["Name", string_type], ["Fields", list_type(FieldValidation_$reflection())], ["IsRowValid", bool_type]]);
}

export const stockChangeColumnName = "Bestandsänderung";

export class ConsumableStockRowValidation extends Record {
    constructor(ConsumableId, ConsumableName, StorageName, Quantity, IsRowValid, ErrorMessage) {
        super();
        this.ConsumableId = ConsumableId;
        this.ConsumableName = ConsumableName;
        this.StorageName = StorageName;
        this.Quantity = Quantity;
        this.IsRowValid = IsRowValid;
        this.ErrorMessage = ErrorMessage;
    }
}

export function ConsumableStockRowValidation_$reflection() {
    return record_type("Shared.Updater.ConsumableStockRowValidation", [], ConsumableStockRowValidation, () => [["ConsumableId", string_type], ["ConsumableName", string_type], ["StorageName", string_type], ["Quantity", float64_type], ["IsRowValid", bool_type], ["ErrorMessage", string_type]]);
}

export class ConsumableStockUpdateDto extends Record {
    constructor(Rows, Comment$) {
        super();
        this.Rows = Rows;
        this.Comment = Comment$;
    }
}

export function ConsumableStockUpdateDto_$reflection() {
    return record_type("Shared.Updater.ConsumableStockUpdateDto", [], ConsumableStockUpdateDto, () => [["Rows", list_type(ConsumableStockRowValidation_$reflection())], ["Comment", string_type]]);
}

export class ToolWithQuantityStockRowValidation extends Record {
    constructor(ToolId, ToolName, StorageName, Quantity, IsRowValid, ErrorMessage) {
        super();
        this.ToolId = ToolId;
        this.ToolName = ToolName;
        this.StorageName = StorageName;
        this.Quantity = (Quantity | 0);
        this.IsRowValid = IsRowValid;
        this.ErrorMessage = ErrorMessage;
    }
}

export function ToolWithQuantityStockRowValidation_$reflection() {
    return record_type("Shared.Updater.ToolWithQuantityStockRowValidation", [], ToolWithQuantityStockRowValidation, () => [["ToolId", string_type], ["ToolName", string_type], ["StorageName", string_type], ["Quantity", int32_type], ["IsRowValid", bool_type], ["ErrorMessage", string_type]]);
}

export class ToolWithQuantityStockUpdateDto extends Record {
    constructor(Rows, Comment$) {
        super();
        this.Rows = Rows;
        this.Comment = Comment$;
    }
}

export function ToolWithQuantityStockUpdateDto_$reflection() {
    return record_type("Shared.Updater.ToolWithQuantityStockUpdateDto", [], ToolWithQuantityStockUpdateDto, () => [["Rows", list_type(ToolWithQuantityStockRowValidation_$reflection())], ["Comment", string_type]]);
}

